export default __webpack_public_path__ + "static/The Home_Image 7_carousel 3@2x-7e8625879d1eae971c52fd3646331ea3.jpg";